import { Field, Input } from '@lightspeed/unified-components-helios-theme/react'
import { useT } from '@transifex/react'
import React from 'react'
import { ApiCustomer } from '@vend/types'
import { CUSTOMER_NAME_FIELD } from '../../../../../react/modals/common/types'
import { LineItemFulfilmentCustomerHeaderView } from '../LineItemFulfilmentCustomerHeaderView'
import { LineItemFulfilmentCustomerContactView } from '../LineItemFulfilmentCustomerContactView'

const TContext = 'Line item fulfilment popover'

export type LineItemFulfilmentNewCustomerDetailsViewProps = {
  customer: ApiCustomer | null
  onFirstNameChange: (firstName: string) => void
  onLastNameChange: (lastName: string) => void
  onEmailChange: (email: string) => void
  onPhoneNumberChange: (phoneNumberType: string, phoneNumber: string) => void
  isEmailInvalid: boolean
}

export const LineItemFulfilmentNewCustomerDetailsView: React.FC<LineItemFulfilmentNewCustomerDetailsViewProps> = ({
  customer,
  onFirstNameChange,
  onLastNameChange,
  onEmailChange,
  onPhoneNumberChange,
  isEmailInvalid,
}: LineItemFulfilmentNewCustomerDetailsViewProps) => {
  const t = useT()

  return (
    <div className="uc-base font-general">
      <div className="flex flex-col gap-6">
        <LineItemFulfilmentCustomerHeaderView />
        <Field size="small" labelSlot={t('First Name', { _context: TContext })}>
          <Input
            placeholder={t('Enter first name', { _context: TContext })}
            onChange={onFirstNameChange}
            name={CUSTOMER_NAME_FIELD.FIRSTNAME}
            value={customer?.first_name || ''}
            size="medium"
          />
        </Field>
        <Field size="small" labelSlot={t('Last Name', { _context: TContext })}>
          <Input
            placeholder={t('Enter last name', { _context: TContext })}
            onChange={onLastNameChange}
            name={CUSTOMER_NAME_FIELD.LASTNAME}
            value={customer?.last_name || ''}
            size="medium"
          />
        </Field>
        <LineItemFulfilmentCustomerContactView
          customer={customer}
          onEmailChange={onEmailChange}
          onPhoneNumberChange={onPhoneNumberChange}
          isEmailInvalid={isEmailInvalid}
        />
      </div>
    </div>
  )
}
